import clsx from 'clsx'
import { Card, CardProps, Input, Link, Title } from 'components/common'

export interface TagsCardProps extends CardProps {
  onClick?: () => void
}

export const TagsCard = ({ ...rest }: TagsCardProps): JSX.Element => (
  <>
    <Card shadow {...rest}>
      <div className={clsx('flex', 'justify-between', 'items-center', 'mb-3')}>
        <Title level={5} style={{ marginBottom: 0 }}>
          タグ
        </Title>
        <Link>すべてのタグを表示する</Link>
      </div>
      <Input />
    </Card>
  </>
)
